/* global jQuery */
import getBrowser from "../util/getBrowser";
import lazyload from "../util/lazyload";
import slick from '../util/slick';

jQuery(document).ready(($) => {
    /**
     * Adds browser class to body
     */
    console.log("app 0.0.13");
    let $body = $("body");
    slick.init();
    lazyload($, false);
    (() => {
        let who = getBrowser();
        if (who[0]) {
            if (!Array.isArray(who)) {
                who = who.split(" ");
            }
            $body.addClass("is-" + who[0].toLowerCase());
        }
    })();

    $(".carousel").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $body.on("click", "[data-toggle]", function () {
        let me = $(this);
        let selector = $(this).attr("data-toggle");
        let classToggle = $(this).attr("data-class-toggle") || "toggle";
        let items;
        switch (selector) {
            case "parent":
                items = $(this).parent();
                // console.log("toggle parent");
                break;
            case "siblings":
                // console.log("toggle siblings");
                items = $(this).siblings();
                break;
            default:
                if (!selector) {
                    items = me;
                } else {
                    items = $(selector);
                }
                break;
        }
        // console.log("click data-toggle", selector, classToggle);
        items.toggleClass(classToggle);
    }).on("click", "[data-untoggle]", function () {
        let me = $(this);
        let selector = $(this).attr("data-untoggle");
        let classToggle = $(this).attr("data-class-toggle") || "toggle";
        let items;
        switch (selector) {
            case "parent":
                items = $(this).parent();
                // console.log("untoggle parent");
                break;
            case "siblings":
                // console.log("untoggle siblings");
                items = $(this).siblings();
                break;
            default:
                if (!selector) {
                    items = me;
                } else {
                    items = $(selector);
                }
                break;
        }
        // console.log("click data-toggle", selector, classToggle);
        items.removeClass(classToggle);
    }).on("click", ".toggle-me > a", function (e) {
        console.log("toggle me");
        let parent = $(this).closest(".toggle-me");
        let classToggle = parent.attr("data-class-toggle") || "toggle";
        parent.toggleClass(classToggle).siblings(".toggle-me").removeClass(classToggle);
    }).on("click", "video", function (e) {
        if (this.paused) {
            // this.play();
            $(this).closest("figure").addClass("should-play").removeClass("should-pause");
        } else {
            // this.pause();
            $(this).closest("figure").addClass("should-pause").removeClass("should-play");
        }
    }).on("item-visible", "video", function (e) {
        if (!$(this).closest("figure").hasClass("should-pause") && this.paused) {
            // console.log("play video");
            this.play()
        }
    }).on("item-invisible", "video", function (e) {
        if (this.isPlaying) {
            // console.log("paused video");
            this.pause()
        }
    }).on("item-visible", ".carte:not(.loaded):not(.loading)", function (e) {
        console.log("map loading");
        let me = $(this);
        me.addClass("loading");
        if (!me.hasClass("load-error")) {
            $('<link>').appendTo($('head')).attr({
                type: 'text/css',
                rel: 'stylesheet'
            }).attr('href', 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css');
            //<link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin=""/>
            $.getScript("/wp-content/themes/thepenier/resources/assets/scripts/util/leaflet.js");
        }
        $.ajax({
            url: ajaxurl,
            async: true,
            method: 'POST',
            data: {
                action: 'loadMap',
            },
            success: (response) => {
                console.log("map loaded");
                $body.find(".carte").html(response);
            },
            error: (response) => {
                console.log("error loading map", id);
                me.addClass("loading-error").removeClass('loading');
            },
        });
    })/*.on("item-visible", ".formulaire:not(.loaded):not(.loading)", function (e) {
        console.log("form loading");
        let me = $(this);
        me.addClass("loading");
        let id = me.attr("data-id");
        $.get(ajaxurl + '?action=gf_button_get_form&form_id=' + id, function (response) {
            me.html(response).fadeIn();
            // if(window['gformInitDatepicker']) {gformInitDatepicker();}
            me.addClass('loaded').removeClass("loading");
            console.log("form loaded");
        });
    })*/.one("mouseenter", "video", function (e) {
        $(this).attr("controls", "controls");
    })
});
